export default "__VITE_ASSET__BixuVPfX__"